import React, {useEffect, useState} from "react"
import {Tabs, Drawer, Card, displayDate} from "../../../components/Elements/appUtils"
import {singlePatientFxn} from "../actions/patients";
import VisitComp from "../../patients/comps/visits";
import PatientSaleList from "./saleList";
import PatientPurchaseList from "./purchaseList";
import PatientCreditNoteList from "./creditNoteList";
import PatientDebitNoteList from "./debitNoteList";
import PatientPaymentInList from "./paymentInList";
import PatientPaymentOutList from "./paymentOutList";

let {TabPane} = Tabs;
const RowTable = (props) => {
    let {title, value, labelWidth = '35%', customCls = ''} = props
    return (
        <div className={`tableRow ${customCls}`}>
            <div className={'title'} style={{width: labelWidth}}>
                {title ? `${title} : ` : ''}
            </div>
            <div>
                {value || "N/A"}
            </div>
        </div>
    )
}


const ProfileComponent = ({patient}) => {
    return (
        <div style={{display: "flex", gap: 10}}>
            <div className={'col-md-5'}>
                <Card title={`Info`}>
                    <div className={'tableBox'}>
                        <RowTable title={'Name'} value={patient.name}/>
                        <RowTable title={'Mobile'} value={patient.mobile}/>
                        <RowTable title={'Email'} value={patient.email}/>
                        <RowTable title={'Country'} value={patient.country}/>
                        <RowTable title={'State'} value={patient.state}/>
                        <RowTable title={'City'} value={patient.city}/>
                        <RowTable title={'Pincode'} value={patient.pincode}/>
                        <RowTable title={'Address'} value={patient.address}/>
                        <RowTable title={'Added On'} value={displayDate(patient.addedOn)}/>
                        <RowTable title={'Gender'} value={patient.gender}/>
                        <RowTable title={'Balance'} value={patient.balance}/>
                        <RowTable title={'Date Of Birth'} value={patient.dateOfBirth}/>
                    </div>
                </Card>
            </div>
            <div className={'col-md-7'}>
                <Card title={'Visits'}>
                    <VisitComp patientId={patient._id}/>
                </Card>
            </div>
        </div>
    )
}
const PatientProfile = (props) => {
    let {visible, onClose, patientId, currentUser} = props;
    let [patientData, setPatientData] = useState({})
    let loadPatient = async () => {
        let {data, success} = await singlePatientFxn({patientId});
        if (success) {
            setPatientData(data)
        }
    }
    useEffect(() => {
        loadPatient()
    }, [patientId])
    return (
        <Drawer visible={visible}
                width={'90%'}
                title={`Patient Profile - ${patientData.name || ""} (${patientData.uhid})`} onClose={onClose}>
            <div className={'mt-2'}>
                <Tabs defaultActiveKey="1" onChange={() => {
                }}>
                    <TabPane tab={"Patient Info"} key="1">
                        {patientData && patientData._id ?
                            <ProfileComponent patient={patientData}/> : null}
                    </TabPane>
                    <TabPane tab={"Sales"} key="2">
                        <PatientSaleList customerId={patientId}/>
                    </TabPane>
                    <TabPane tab={"Purchases"} key="3">
                        <PatientPurchaseList customerId={patientId}/>
                    </TabPane>
                    <TabPane tab={"Sale Returns"} key="4">
                        <PatientCreditNoteList customerId={patientId}/>
                    </TabPane>
                    <TabPane tab={"Purchase Returns"} key="5">
                        <PatientDebitNoteList customerId={patientId} currentUser={currentUser}/>
                    </TabPane>
                    <TabPane tab={"Payment In"} key="6">
                        <PatientPaymentInList customerId={patientId}/>
                    </TabPane>
                    <TabPane tab={"Payment Out"} key="7">
                        <PatientPaymentOutList customerId={patientId}/>
                    </TabPane>
                </Tabs>
            </div>
        </Drawer>
    )
}
export default PatientProfile